// Metadonnees des groupes/champs STS (libelles, type A/N, longueur max).
// Port fidele de frmSTS.ChargerDonneesStructure (frmSTS.vb l.1234-1448).
// Libelles en francais sans accents (convention projet).
//
// Forme : STS_METADATA[groupe] = { nom, champs: { [noChamp]: {libelle, type, lg} } }
// type : 'A' (alpha) | 'N' (numerique). noChamp est 1-based (comme le legacy).

export const STS_METADATA = {
    107: {
        nom: 'Donnees mutuelle',
        champs: {
            1: { libelle: 'Identification mutuelle', lg: 8, type: 'A' },
            2: { libelle: 'Garanties effectives', lg: 8, type: 'A' },
            3: { libelle: 'Indicateur de traitement mutuelle', lg: 2, type: 'N' },
            4: { libelle: 'Type de services associes', lg: 1, type: 'A' },
            5: { libelle: 'Services associes au contrat', lg: 17, type: 'A' },
            6: { libelle: 'Code aiguillage STS', lg: 1, type: 'A' },
        },
    },
    108: {
        nom: 'Periode de droits mutuelle',
        champs: {
            1: { libelle: 'Date de debut droits mutuelle', lg: 12, type: 'N' },
            2: { libelle: 'Date de fin droits mutuelle', lg: 12, type: 'N' },
        },
    },
    109: {
        nom: 'Donnees AMC',
        champs: {
            1: { libelle: 'Numero de complementaire B2', lg: 10, type: 'A' },
            2: { libelle: 'Numero de complementaire EDI', lg: 19, type: 'A' },
            3: { libelle: "Numero d'adherent AMC", lg: 8, type: 'A' },
            4: { libelle: 'Indicateur de traitement AMC', lg: 2, type: 'N' },
            5: { libelle: 'Date de debut de validite des donnees AMC', lg: 12, type: 'N' },
            6: { libelle: 'Date de fin de validite des donnees AMC', lg: 12, type: 'N' },
            7: { libelle: 'Code de routage flux AMC', lg: 2, type: 'A' },
            8: { libelle: "Identifiant d'hote", lg: 3, type: 'A' },
            9: { libelle: 'Nom de domaine AMC', lg: 20, type: 'A' },
            10: { libelle: 'Code aiguillage STS', lg: 1, type: 'A' },
            11: { libelle: 'Type de services associes', lg: 1, type: 'A' },
            12: { libelle: 'Services associes au contrat', lg: 17, type: 'A' },
        },
    },
    111: {
        nom: "Donnees benef. pour l'AMC",
        champs: {
            1: { libelle: 'Donnees RUF benef. compl.', lg: 115, type: 'A' },
        },
    },
    1321: {
        nom: 'Donnees compl. facture',
        champs: {
            1: { libelle: 'Type de contrat', lg: 2, type: 'N' },
            2: { libelle: 'No organisme complementaire', lg: 10, type: 'A' },
            3: { libelle: 'No adherent', lg: 8, type: 'A' },
            4: { libelle: 'Donnees AMC zone 1', lg: 16, type: 'A' },
            5: { libelle: 'Donnees AMC zone 2', lg: 4, type: 'A' },
            6: { libelle: 'No organisme complementaire EDI', lg: 19, type: 'A' },
            7: { libelle: 'Code application', lg: 2, type: 'A' },
            8: { libelle: 'Code de routage flux AMC', lg: 2, type: 'A' },
            9: { libelle: 'Domaine', lg: 20, type: 'A' },
            10: { libelle: 'Indicateur de traitement AMC ou mutuelle', lg: 2, type: 'N' },
            11: { libelle: 'Identifiant hote gestionnaire', lg: 3, type: 'A' },
            12: { libelle: 'Zone supplementaire certifiee', lg: 15, type: 'A' },
            13: { libelle: 'Zone supplementaire non certifiee', lg: 7, type: 'A' },
        },
    },
    1322: {
        nom: 'Organisme mutualiste',
        champs: { 1: { libelle: 'Top mutualiste', lg: 1, type: 'A' } },
    },
    1330: {
        nom: 'Donnees compl. additionnelles',
        champs: {
            1: { libelle: 'No operateur de reglement AMC', lg: 10, type: 'A' },
            2: { libelle: 'Contexte conventionnel AMC', lg: 34, type: 'A' },
            3: { libelle: 'Zone supplementaire certifiee', lg: 48, type: 'A' },
        },
    },
    1440: {
        nom: 'Forcage niveau facture',
        champs: {
            1: { libelle: 'Indicateur de forcage AMO niveau facture', lg: 1, type: 'A' },
            2: { libelle: 'Indicateur de forcage AMC niveau facture', lg: 1, type: 'A' },
            3: { libelle: 'No de version de referentiel electronique SRT', lg: 4, type: 'N' },
        },
    },
    1450: {
        nom: 'Tarif. compl.',
        champs: {
            1: { libelle: 'Identifiant du module STS', lg: 1, type: 'A' },
            2: { libelle: 'No de version du module STS', lg: 4, type: 'A' },
        },
    },
    1610: {
        nom: 'Prestation',
        champs: {
            1: { libelle: 'No de la prestation', lg: 4, type: 'N' },
            2: { libelle: "Date d'execution", lg: 12, type: 'N' },
            3: { libelle: "Lieu d'execution", lg: 1, type: 'N' },
            4: { libelle: 'Code prestation', lg: 4, type: 'A' },
            5: { libelle: 'Code complement prestation', lg: 1, type: 'A' },
            6: { libelle: 'Montant des honoraires (depassement compris)', lg: 7, type: 'N' },
            7: { libelle: 'Qualificatif de la depense', lg: 1, type: 'A' },
            8: { libelle: 'Coefficient', lg: 6, type: 'N' },
            9: { libelle: 'Quantite', lg: 2, type: 'N' },
            10: { libelle: 'Denombrement', lg: 2, type: 'N' },
            11: { libelle: 'Prix unitaire', lg: 7, type: 'N' },
            12: { libelle: 'Base de remboursement', lg: 7, type: 'N' },
            13: { libelle: 'Taux applicable a la prestation', lg: 3, type: 'N' },
            14: { libelle: "Montant remboursable par l'AMO", lg: 7, type: 'N' },
            15: { libelle: "Montant theoriquement remboursable par l'AMC", lg: 7, type: 'N' },
            16: { libelle: "Mt majoration TM a la charge de l'assure", lg: 7, type: 'N' },
        },
    },
    1620: {
        nom: 'Ind. Forf. de deplacement',
        champs: {
            1: { libelle: 'No de la prestation IFD', lg: 4, type: 'N' },
            2: { libelle: 'Date deplacement IFD', lg: 12, type: 'N' },
            3: { libelle: 'Code IFD', lg: 5, type: 'A' },
            4: { libelle: 'Montant de IFD', lg: 7, type: 'N' },
            5: { libelle: 'Quantite (IFD)', lg: 2, type: 'N' },
            6: { libelle: 'Prix unitaire (IFD)', lg: 7, type: 'N' },
            7: { libelle: 'Base de remboursement IFD', lg: 7, type: 'N' },
            8: { libelle: "Taux applicable a l'indemnite forfaitaire", lg: 3, type: 'N' },
            9: { libelle: "Montant remboursable par l'AMO", lg: 7, type: 'N' },
            10: { libelle: "Montant theoriquement remboursable par l'AMC", lg: 7, type: 'N' },
            11: { libelle: 'Qualificatif de la depense (IFD)', lg: 1, type: 'A' },
            12: { libelle: "Mt majoration TM a la charge de l'assure", lg: 7, type: 'N' },
        },
    },
    1630: {
        nom: 'Ind. Kilom. de deplacement',
        champs: {
            1: { libelle: 'No de la prestation IK', lg: 4, type: 'N' },
            2: { libelle: 'Date deplacement IK', lg: 12, type: 'N' },
            3: { libelle: "Type d'IK", lg: 5, type: 'A' },
            4: { libelle: 'Nombre de kilometres', lg: 2, type: 'A' },
            5: { libelle: "Montant de l'IK", lg: 7, type: 'N' },
            6: { libelle: 'Prix unitaire du kilometre', lg: 7, type: 'N' },
            7: { libelle: "Base de remboursement par l'AMO", lg: 7, type: 'N' },
            8: { libelle: "Taux applicable a l'IK", lg: 3, type: 'N' },
            9: { libelle: "Montant remboursable par l'AMO", lg: 7, type: 'N' },
            10: { libelle: "Montant theoriquement remboursable par l'AMC", lg: 7, type: 'N' },
            11: { libelle: 'Qualificatif de la depense (IK)', lg: 1, type: 'A' },
            12: { libelle: "Mt majoration TM a la charge de l'assure", lg: 7, type: 'N' },
        },
    },
    1910: {
        nom: 'Total de la facture',
        champs: {
            1: { libelle: 'Nombre de prestations', lg: 3, type: 'N' },
            2: { libelle: 'Total des montants factures', lg: 8, type: 'N' },
            3: { libelle: "Total remboursable par l'AMO", lg: 8, type: 'N' },
            4: { libelle: 'Total de la participation assure', lg: 8, type: 'N' },
            5: { libelle: "Total theoriquement remboursable par l'AMC", lg: 8, type: 'N' },
            6: { libelle: "Total remboursable par l'AMC", lg: 8, type: 'N' },
        },
    },
    2010: {
        nom: 'Forcage AMC niveau acte',
        champs: {
            1: { libelle: 'No de la prestation (de rattachement)', lg: 4, type: 'N' },
            2: { libelle: 'Indicateur de forcage AMC niveau acte', lg: 1, type: 'A' },
        },
    },
    3700: {
        nom: 'Contexte de tarification',
        champs: {
            1: { libelle: 'Top CMU', lg: 1, type: 'A' },
            2: { libelle: 'Top medecin referent', lg: 1, type: 'A' },
        },
    },
    3710: {
        nom: 'Formule AMC au niveau acte',
        champs: {
            1: { libelle: 'No de la prestation', lg: 4, type: 'N' },
            2: { libelle: 'No de formule', lg: 3, type: 'A' },
            3: { libelle: 'Nombre de parametres', lg: 2, type: 'N' },
        },
    },
    3715: {
        nom: 'Libelle de la formule AMC',
        champs: {
            1: { libelle: 'No de la prestation', lg: 4, type: 'N' },
            2: { libelle: 'Libelle', lg: 255, type: 'A' },
        },
    },
    3720: {
        nom: 'Formule AMC au niveau facture',
        champs: {
            1: { libelle: 'No de formule', lg: 3, type: 'A' },
            2: { libelle: 'Nombre de parametres', lg: 2, type: 'N' },
        },
    },
    3770: {
        nom: 'Zone tampon AMC',
        champs: { 1: { libelle: 'Tampon', lg: 255, type: 'A' } },
    },
};

// Libelle par defaut quand le groupe/champ n'est pas reference (cf valeurs par
// defaut de ChargerDonneesStructure : "GroupeN" / "ChampN", type 'A', lg 255).
export function metaChamp(groupe, noChamp) {
    const g = STS_METADATA[groupe];
    if (g && g.champs && g.champs[noChamp]) {
        return { ...g.champs[noChamp], nomGroupe: `${groupe} ${g.nom}` };
    }
    return {
        libelle: `Champ${noChamp}`,
        lg: 255,
        type: 'A',
        nomGroupe: g ? `${groupe} ${g.nom}` : `Groupe${groupe}`,
    };
}
